import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { formatDate } from "../components/DateFormatServices";
import APIService from "../components/postServices";
import { showToast } from "../components/toastServices";
import PublicHeader from "../components/header";
import { RadioButton } from "primereact/radiobutton";

import { useEMIPlans } from "../components/grayGuestApi.service";

import grayQuestLogo from "../assets/grayquest-logo.png";
import ccAvenueLogo from "../assets/ccavenue-logo.png";
import auxiloLogo from "../assets/auxilo.png";

import NewArv from "../assets/New.png";

import { formatNumberWithCommas, removeCountryCode } from "../utils/utils";
import Preloader from "../components/Preloader";
function PaymentForm() {
  const navigate = useNavigate();
  const location = useLocation();
  const [ApplicationData, setApplicationData] = useState(null);
  const [grCloseFlag, setGrCloseFlag] = useState(1);
  const [loading, setLoading] = useState(false);
  const [GqLoad, setGqLoad] = useState(1);
  // Use a single useEffect to handle setting ApplicationData and redirection

     // 2. Add an additional loading state specific for the refresh operation
  const [refreshLoading, setRefreshLoading] = useState(false);

  // const userName = useSelector(selectFirstName) ;
  const { emiPlans, getEMIPlans, totalEMIAmount } = useEMIPlans();

  const ccAvenuePaymentOptions = [
    { value: "OPTCRDC", label: "Credit Card" },
    { value: "OPTDBCRD", label: "Debit Card" },
    { value: "OPTNBK", label: "Net Banking" },
    { value: "OPTUPI", label: "UPI" },
  ];
  const [paymentMethodData, setPaymentMethod] = useState({
    paymentMethod: "ccAvenue",
  });

  //  GrayQuest
  // 1. Update the script loading useEffect
    useEffect(() => {
      // Load the ERP SDK script
      const loadScript = () => {
        return new Promise((resolve, reject) => {
          const id = "gqerp-jssdk";
          if (document.getElementById(id)) {
            resolve(); // Script already loaded
            return;
          }

          const script = document.createElement("script");
          script.async = true;
          script.type = "text/javascript";
          script.src = process.env.REACT_APP_EMI_URL;
          script.id = id;

          script.onload = () => {
            // Wait a short time to ensure SDK initialization completes
            setTimeout(() => {
              if (window.GqErpSDK) {
                console.log("GqErpSDK loaded successfully");
                resolve();
              } else {
                console.error("GqErpSDK failed to initialize");
                reject();
              }
            }, 500);
          };

          script.onerror = () => {
            console.error("Failed to load GqErpSDK script");
            reject();
          };

          const firstScript = document.getElementsByTagName("script")[0];
          firstScript.parentNode.insertBefore(script, firstScript);
        });
      };

      // Call the loadScript function immediately, not dependent on window.load
      loadScript()
        .then(() => {
          console.log("GqErpSDK ready to use");
        })
        .catch((error) => {
          console.error("Error loading GqErpSDK:", error);
        });

      // Set up event listeners
      const handlePopupClose = (e) => {
        console.log("GQ Popup Close", e.gqData);
        setGrCloseFlag(grCloseFlag + 1);
        refreshPaymentData(ApplicationData);
      };

      const handleActivity = (e) => {
        console.log("GQ Activity = ", e.gqData);
      };

      const handleSuccess = (e) => {
        console.log("GQ SUCCESS = ", e.gqData);
      };

      const handleError = (e) => {
        console.log("GQ Error = ", e.gqData);
      };

      document.addEventListener("onGqPopupClose", handlePopupClose);
      document.addEventListener("onGqActivity", handleActivity);
      document.addEventListener("onGqSuccess", handleSuccess);
      document.addEventListener("onGqError", handleError);

      // Clean up event listeners when component unmounts
      return () => {
        document.removeEventListener("onGqPopupClose", handlePopupClose);
        document.removeEventListener("onGqActivity", handleActivity);
        document.removeEventListener("onGqSuccess", handleSuccess);
        document.removeEventListener("onGqError", handleError);
      };
    }, []);
  //  end GrayQuest


  const handleCardClick = (option) => {
    setPaymentMethod({
      ...paymentMethodData,
      paymentMethod: option,
    });
  };

  const paymentMethodChange = (e) => {
    setPaymentMethod({
      ...paymentMethodData,
      paymentMethod: e.value,
    });
  };

  useEffect(() => {
    const data = location.state?.data ;

    if (data) {
      setApplicationData(data);
      getEMIPlans(data && data.totalFeeDueAmount);
    } else {
      navigate("/");
    }
  }, [location.state, navigate, ApplicationData]);
  // console.log("PaymentForm", ApplicationData);

  const [CCAvenuePaymentSetup, setCCAvenuePaymentSetup] = useState();

  useEffect(() => {
    APIService.get(`/CCAvenuePayment/CCAvenuePaymentSetup`)
      .then((response) => {
        setCCAvenuePaymentSetup(response.data.dataSet);
      })
      .catch((error) => {
        // Handle API call errors here
        console.error("Error:", error);
      });
  }, []);

  const refreshPaymentData = async () => {
 setRefreshLoading(true);
    const data = JSON.parse(localStorage.getItem("appData"));
    console.log("refreshPaymentData ApplicationData ApplicationData 2025:", ApplicationData);
    // Ensure we have ApplicationData before proceeding
    if (data.appNo==null || data.appNo===undefined) {
      console.error("ApplicationData is null in refreshPaymentData");
      navigate("/");
      return;
    }
  
    console.log("refreshPaymentData with data:", data);
    
    try {
      const response = await APIService.Post(`/refreshForQuickPayment`, data?.tokenApiDto);
        // accessToken: data?.tokenApiDto?.accessToken,
        // refreshToken: data?.tokenApiDto?.refreshToken,
        // studentNo: data?.tokenApiDto?.StudentNo,  // Note the capital S
        // class: data?.tokenApiDto?.Class,          // Note the capital C
        // section: data?.tokenApiDto?.Section,      // Note the capital S
        // mobile: data?.tokenApiDto?.Mobile,        // Note the capital M
        // email: data?.tokenApiDto?.Email,          // Note the capital E
        // dob: data?.tokenApiDto?.Dob,              // Note the capital D
      // });
      
      if (response) {
        console.log("refresh response:", response);
        localStorage.removeItem("appData");
        localStorage.setItem("appData", JSON.stringify(response.dataSet));
        setApplicationData(response.dataSet);
        getEMIPlans(response.dataSet?.totalFeeDueAmount);
      } else {
        navigate("/");
      }
    } catch (error) {
      setRefreshLoading(false);
      console.error("Error in refreshPaymentData:", error);
      navigate("/");
    }finally {
      setRefreshLoading(false);
    }
  };


  const [paymentFormData, setPaymentFormData] = useState({});

  useEffect(() => {
    ApplicationData &&
      setPaymentFormData({
        studentNo: ApplicationData && ApplicationData.tokenApiDto.studentNo,
        class: ApplicationData && ApplicationData.tokenApiDto.class,
        section: ApplicationData && ApplicationData.tokenApiDto.section,
        mobile: ApplicationData && ApplicationData.tokenApiDto.mobile,
        email: ApplicationData && ApplicationData.tokenApiDto.email,
        dob: ApplicationData && ApplicationData.tokenApiDto.dob,
        // parentName: ApplicationData.tokenApiDto.parentName,
        // relation: ApplicationData.tokenApiDto.relation,
        amount: ApplicationData && ApplicationData.totalFeeDueAmount,
        paymentOption: "",
        prvEmiStatus: ApplicationData && ApplicationData.prv_emi_status,
        appNo: ApplicationData && ApplicationData.AppNo,
        classCode: ApplicationData && ApplicationData.class_code,
        academicYear: ApplicationData && ApplicationData.academic_year,
        orderId: ApplicationData && ApplicationData.order_id,
      });
  }, [ApplicationData]);
  const [error, setError] = useState({});

  const [amountError, setAmountError] = useState("");
  const [paymentOptionError, setPaymentOptionError] = useState("");

  const PaymentFormDataChange = (event) => {
    const { name, value } = event.target;

    // Update the form state with the new value
    setPaymentFormData({
      ...paymentFormData,
      [name]: value,
    });
  };

  // const setPaymentFormData = (error, input) => {
  //   setAmountError(error);
  //   setError(true);
  // };

  const handleSubmit = async (e) => {
    e.preventDefault();
    let isValid = true;
    let amount = paymentFormData.amount;
    let paymentOption = paymentFormData.paymentOption;

    if (amount === 0 || amount === "0" || amount === "") {
      setAmountError("Please input Amount");
      setError(true);
      isValid = false;
    }
    if (!paymentOption) {
      setPaymentOptionError("Please select payment option");
      isValid = false;
    }

    if (isValid) {
      try {
        const response = await APIService.Post(
          `/CCAvenuePayment/quickPaymentInitiate`,
          paymentFormData
        );
        console.log("response", response);
        if (response.responseCode === 1) {
          // initiateTransaction(response.dataSet);
          // Navigate to the new location ("/Payonline") and replace the current entry in the history
          // navigate("/Payment", { state: { data: "/" }, replace: true });
          navigate("/Payment", {
            state: {
              data: response.dataSet,
              link: "/",
              status: "payment",
            },
            replace: true,
          });
          setApplicationData(null);
          // setPaymentFormData({});
        }
      } catch (error) {
        // showToast("error", error.response.data.responseMessage);
      }
    }
  };

  const breadcrumb = [{ label: "Online Payment", url: "/" }];

  const handleEMIPaymentButtonClick = () => {
    let isValid = true;
    let mobile = paymentFormData.mobile;
    let email = paymentFormData.email;
    let amount = paymentFormData.amount;
  
   
    if (amount === 0 || amount === "0" || amount === "") {
      setAmountError("Please input Amount");
      setError(true);
      isValid = false;
    }

    console.log("ApplicationData.classAmount 2025", ApplicationData);
  
    if (amount > ApplicationData.totalFeeDueAmount) {
      setAmountError("Amount should be less than due amount or equal");
      setError(true);
      isValid = false;
      return;
    }
  

 


    if (isValid) {
      if (window.GqErpSDK) {
        try {
          window.GqErpSDK.setOptions({
            env: process.env.REACT_APP_GQ_MODE,
            auth: {
              client_id: process.env.REACT_APP_GQ_CLIENT_ID,
              client_secret: process.env.REACT_APP_GQ_SECRET_KEY,
              api_key: process.env.REACT_APP_GQ_API_KEY
            },
            reference_id: "GQ_" + (ApplicationData && ApplicationData.order_id),
            student_id: ApplicationData && ApplicationData.tokenApiDto.studentNo,
            customer_mobile: removeCountryCode(mobile),
            customer_details: {
              customer_email: email,
          },
            pp_config: {
              slug: process.env.REACT_APP_GQ_SLUG,
            },
            fee_headers: {
              total_payable: amount,
            },
            notes: {
              "unique_number": ApplicationData && ApplicationData.order_id,
              orderNo: "GQ_" + (ApplicationData && ApplicationData.order_id),
              academic_year: ApplicationData && ApplicationData.academic_year,
              class_code: ApplicationData && ApplicationData.class_code,
              AppNo: ApplicationData && ApplicationData.appNo,
              StudNo: ApplicationData && ApplicationData.tokenApiDto.studentNo,
              total_due: amount,
              payment_for: "Fees",
              class: ApplicationData && ApplicationData.class_Description,
              "school": "St.Jude's Public School",
              "board": ApplicationData && ApplicationData.curriculum,
              "location": "Kotagiri",
              "platform": "St.Jude's Quick Online Payment Portal",
              "program": "Fees"
            },
            customizations: {
              logo_url: "https://www.stjudesonline.in/common/footerlogo.png",
              theme: {
                theme_color: "#970f2f",
              },
            },
          });
          window.GqErpSDK.render();
        } catch (error) {
          console.error("Error configuring GqErpSDK:", error);
          showToast("error", "Failed to initialize payment. Please try again.");
        }
      } else {
        console.error("GqErpSDK is not loaded yet");
        // Try to load the script again
        const script = document.createElement("script");
        script.async = true;
        script.type = "text/javascript";
        script.src = process.env.REACT_APP_EMI_URL;
        script.id = "gqerp-jssdk-retry";
        
        script.onload = () => {
          setTimeout(() => {
            if (window.GqErpSDK) {
              console.log("GqErpSDK loaded on retry");
              handleEMIPaymentButtonClick(); // Try again after loading
            } else {
              showToast("error", "Payment system is currently unavailable. Please try again later or use another payment method.");
            }
          }, 1000);
        };
        
        document.head.appendChild(script);
      }
    }
  };

  const isPaymentEligible = () => {
     
    const data = JSON.parse(localStorage.getItem("appData"));

    return [5, 8, 9, 10, 0].includes(
      data && data.prv_emi_status
    );
  };

  function getEMIStatus( ) {
    const blockedNumbers = [5, 8, 9, 10, 0];
    const data = JSON.parse(localStorage.getItem("appData"));
    if (blockedNumbers.includes( data && data.prv_emi_status)) {
      return ""; // Return empty string if input is blocked
    }
  
    return "EMI Application form has been successfully submitted, waiting for Approval from GrayQuest";
  }


  function isAmountEnable( ) {
   
    const data = JSON.parse(localStorage.getItem("appData"));
    if( data && data.isPartialPaymentStatus === 0) {
      return true;
    }else{
      return false;
    }
  
    
  }
  

  const handleAuxiloClick = () => {
    window.open("https://onefin.auxilo.com/sp/customer-signup", "_blank");
  };


  return (
    <div className="main-page">
        {refreshLoading && <Preloader />}
      <div>
        {" "}
        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          theme="colored"
        />
        <PublicHeader breadcrumb={breadcrumb} title={"Online Payment"} />
        <div className="content-wrapper  mt-10">
          <div className="col-md-12">
            <h3 className="text-center">
              Make Online Payment
              {/* <small>Make payment and submit the application form</small> */}
            </h3>

            <div className=" reg">
              <div className="box-header text-center">
                <h3 className="box-title">Information</h3>
              </div>
              {/* style={{ padding: "0 15%" }} */}
              <div className="box-body">
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Student Name :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.studentName}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Student No :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData &&
                          ApplicationData.tokenApiDto.studentNo}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Date of Birth :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {formatDate(
                          ApplicationData && ApplicationData.tokenApiDto.dob
                        )}
                      </label>
                    </div>

                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Class :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.tokenApiDto.class}-
                        {ApplicationData && ApplicationData.tokenApiDto.section}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Mobile :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.tokenApiDto.mobile}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Email :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData && ApplicationData.tokenApiDto.email}
                      </label>
                    </div>
                  </div>
                  <div className="col-md-6">
                    {/* <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                       style={{ fontWeight: "400" }}
                      >
                        Reference No :
                      </label>
                      <label className="col-md-8 col-form-label">
                        {ApplicationData.referenceNo}
                      </label>
                    </div> */}
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        style={{ fontWeight: "400" }}
                      >
                        Total Amount Due:
                        <br />
                        <small style={{ fontWeight: "400" }}>
                          (as on{" "}
                          {formatDate(
                            ApplicationData && ApplicationData.endDate
                          )}
                          )
                        </small>
                      </label>
                      <label className="col-md-8 col-form-label">
                        {/* INR {ApplicationCost} */}
                        INR{" "}
                        {ApplicationData && ApplicationData.totalFeeDueAmount}
                      </label>
                    </div>
                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        // style={{ fontWeight: "400" }}
                      >
                        Amount
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                        :
                      </label>
                      <input
                        type="number"
                        className="form-control form-control-sm"
                        style={isAmountEnable() ? { backgroundColor: "#e9ecef", color: "#6c757d" } : {}}
                        placeholder="Amount"
                        id="amount"
                        name="amount"
                        value={paymentFormData.amount}
                        onChange={PaymentFormDataChange}
                        onFocus={() => setAmountError("")}
                        disabled={ isAmountEnable( )}
                      />
                      {error && amountError && (
                        <span className="redColor ml-2">{amountError}</span>
                      )}
                    </div>

                    {/* <div className="form-group row">
                      <label className="col-md-4 col-form-label">
                        Payment option
                        <i aria-hidden="true" className="ml-2 redColor">
                          {" "}
                          *{" "}
                        </i>{" "}
                        :
                      </label>
                      <div className="col-12 md:col-12 xl:col-8">
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTCRDC"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTCRDC"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2 mr-2">Credit Card</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTDBCRD"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTDBCRD"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2 mr-2">Debit Card</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTNBK"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTNBK"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2">Net Banking</label>
                        <br />
                        <RadioButton
                          inputId="ingredient1"
                          name="paymentOption"
                          value="OPTUPI"
                          onChange={PaymentFormDataChange}
                          checked={paymentFormData.paymentOption === "OPTUPI"}
                          onFocus={() => setPaymentOptionError(null)}
                        />

                        <label className="ml-2">UPI</label>
                      </div>
                      {error && paymentOptionError && (
                        <span className="redColor ml-2">
                          {paymentOptionError}
                        </span>
                      )}
                    </div> */}

                    {/* <br /> */}

                    {/* <div
                      className="button-container"
                      style={{ justifyContent: "center" }}
                    >
                      <button
                        className="btn btn-danger btn-lg"
                        onClick={handleSubmit}
                        style={{ width: "250px" }}
                      >
                        Make Payment
                      </button>
                    </div> */}

                    {/* Gq and CCav 2025 */}

                    <div className="form-group row">
                      <label
                        className="col-md-4 col-form-label"
                        // style={{ fontWeight: "400" }}
                      >
                        Payment Methods
                      </label>
                    </div>

                    <div className="row mb-3  ">
                      <div className="col-10">
                        {/* <label>Payment Methods</label> */}
                        <div className="payment-methods row row-cols-1 row-cols-md-2 g-3 mt-2 ">
                          {/* Payment Method 1 - GrayQuest */}
                          <div
                            className="col d-flex "
                            onClick={() => handleCardClick("grayQuest")}
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="payment-method card position-relative d-flex flex-column h-100 w-100 bg-white"
                              style={{
                                border:
                                  paymentMethodData.paymentMethod ===
                                  "grayQuest"
                                    ? "2px solid #93c7de"
                                    : "1px solid #dee2e6",
                              }}
                            >
                             
                              {/* <img
                                src={NewArv}
                                alt="GrayQuest"
                                
                                style={{
                                  width: "75px",
                                  height: "auto",
                                  left: "-111px",
                                  top: "-28px",
                                  position: "relative",
                                }}
                              /> */}

                              
                              <RadioButton
                                inputId="grayQuest"
                                name="paymentOption"
                                
                                style={{
                                  top: "0px",
                                  left: "-150px",
                                  position: "relative",
                                }}
                                value="grayQuest"
                                checked={
                                  paymentMethodData.paymentMethod ===
                                  "grayQuest"
                                }
                                onChange={() => handleCardClick("grayQuest")}
                              />

                              
                              <div className="d-flex mt-1 ml-5">
                                <img
                                  src={grayQuestLogo}
                                  alt="GrayQuest"
                                  style={{
                                    width: "200px",
                                    height: "auto",
                                    position: "relative",
                                    top: "-30px",
                                    left: "-10px",
                                  }}
                                />
                              </div>

                              
                              <p
                                className="small text-secondary text-center"
                                style={{
                                  fontSize: "smaller",
                                  position: "relative",
                                  top: "-55px",
                                  left: "15px",
                                }}
                              >
                                Pay as low as{" "}
                                <span className="fw-bold text-dark font-weight-bold">
                                  Rs.{" "}
                                  {formatNumberWithCommas(
                                    totalEMIAmount && totalEMIAmount
                                  )}
                                </span>{" "}
                                per month
                              </p>

                              
                              <div
                                className="mt-auto text-center p-0"
                                style={{
                                  backgroundColor: "#f3f1ff",
                                  borderTop: "none",
                                  borderRadius: "0 0 8px 8px",
                                  position: "relative",
                                  bottom: "-15px",
                                  padding: "5px",
                                }}
                              >
                                <p
                                  className="small text-primary m-0"
                                  style={{ fontSize: "smaller" }}
                                >
                                  Pay in small, convenient monthly payments
                                </p>
                              </div>
                            </div>
                          </div>

                          {/* Payment Method 2 - CCAvenue */}
                          <div
                            className="col d-flex"
                            onClick={() => handleCardClick("ccAvenue")}
                            style={{ cursor: "pointer" }}
                          >
                            <div
                              className="payment-method card p-3 position-relative d-flex flex-column h-100 w-100 bg-white"
                              style={{
                                border:
                                  paymentMethodData.paymentMethod === "ccAvenue"
                                    ? "2px solid #93c7de"
                                    : "1px solid #dee2e6",
                              }}
                            >
                              {/* Radio Button */}
                              <RadioButton
                                inputId="ccAvenue"
                                name="paymentOption"
                                // className="position-absolute"
                                style={{
                                  top: "12px",
                                  left: "-111px",
                                  position: "relative",
                                }}
                                value="ccAvenue"
                                checked={
                                  paymentMethodData.paymentMethod === "ccAvenue"
                                }
                                onChange={() => handleCardClick("ccAvenue")}
                              />

                              {/* Payment Logo */}
                              <div
                                className="d-flex mt-1 ml-4"
                                style={{
                                  position: "relative",
                                  top: "-15px",
                                  left: "-25px",
                                }}
                              >
                                <img
                                  src={ccAvenueLogo}
                                  alt="CCAvenue"
                                  style={{ width: "135px", height: "auto" }}
                                />
                              </div>

                              {/* Payment Options */}
                              <div className="payment-options  w-100 ">
                                {ccAvenuePaymentOptions.map((option) => (
                                  <div
                                    key={option.value}
                                    className="form-check d-flex  ml-5"
                                    style={{ marginBottom: "7px" }}
                                  >
                                    <RadioButton
                                      inputId={option.value}
                                      name="paymentOption"
                                      value={option.value}
                                      onChange={PaymentFormDataChange}
                                      checked={
                                        paymentFormData.paymentOption ===
                                        option.value
                                      }
                                      onFocus={() =>
                                        setPaymentOptionError(null)
                                      }
                                      // onFocus={() =>
                                      //   handleError(null, "paymentOption")
                                      // }
                                    />
                                    <label className="form-check-label ms-2 ml-2">
                                      {option.label}
                                    </label>
                                  </div>
                                ))}

                                {error && paymentOptionError && (
                                  <span className="redColor ml-2">
                                    {paymentOptionError}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>

                      
                              {/* Payment Method - Auxilo */}
                             <div className="payment-methods row row-cols-1 row-cols-md-2 g-3  ">
                              <div className="col d-flex">
                                <div
                                  className="payment-method card auxilo-card position-relative d-flex flex-column h-100 w-100 bg-white"
                                  onClick={handleAuxiloClick}
                                  style={{
                                    cursor: "pointer",
                                    border:
                                      paymentMethodData.paymentMethod ===
                                      "auxilo"
                                        ? "2px solid #4CAF50"
                                        : "1px solid #e0e0e0",
                                    borderRadius: "12px",
                                    transition: "all 0.3s ease",
                                  }}
                                >
                                  {/* TOP ICON */}
                                   <img
                                src={NewArv}
                                alt="GrayQuest"
                                
                                style={{
                                  width: "75px",
                                  height: "auto",
                                  left: "-111px",
                                  top: "-28px",
                                  position: "relative",
                                }}
                              />
                                  {/* LOGO */}
                                  <div className="text-center mt-3">
                                    <img
                                      src={auxiloLogo}
                                      alt="Auxilo"
                                      style={{ width: "215px" }}
                                    />
                                  </div>

                                  {/* TITLE */}
                                  <div className="text-center ">
                                    <h6 className="m-0 fw-bold">
                                      Pay in Installments
                                    </h6>
                                  </div>

                                  <div
                                    className="mt-auto text-center "
                                    style={{
                                      backgroundColor: "#f3f1ff",
                                      borderTop: "none",
                                      borderRadius: "0 0 8px 8px",
                                      position: "relative",
                                      bottom: "-15px",
                                      padding: "5px",
                                    }}
                                  >
                                    <p className="small text-primary m-0">
                                      Click to continue →
                                    </p>
                                  </div>
                                </div>
                              </div>
                            </div>

                        </div>
                      </div>
                    </div>
                    
                   
                    <div className="d-flex justify-content-end align-items-center gap-3">
                      {paymentMethodData.paymentMethod !== "grayQuest" ? (
                        <button
                          className="btn btn-info btn-lg pull-right"
                          onClick={handleSubmit}
                          style={{
                            width: "250px",
                            backgroundColor: !isPaymentEligible() ? "#b8daff" : "",
                            borderColor: !isPaymentEligible()  ? "#b8daff" : "",
                            color: !isPaymentEligible() ? "#fff" : ""
                          }}
                          disabled={!isPaymentEligible()}
                        >
                          Make Payment
                        </button>
                      ) : (
                        <button
                          className="btn btn-info btn-lg pull-right"
                          onClick={handleEMIPaymentButtonClick}
                          style={{
                            width: "250px",
                            backgroundColor: !isPaymentEligible() ? "#b8daff" : "",
                            borderColor: !isPaymentEligible()  ? "#b8daff" : "",
                            color: !isPaymentEligible() ? "#fff" : ""
                          }}
                          disabled={!isPaymentEligible()}
                        >
                          Pay In EMIs
                        </button>
                      )}
                    </div>
                    <div className="d-flex justify-content-end align-items-center ">
                    <p   className="  pull-right  " style={{ fontSize: "12px" ,fontWeight:"bold",color:"red" }} >{getEMIStatus()}</p>
                    </div>

                    {/* Gq and CCav 2025 */}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default PaymentForm;
